import { Grid, Skeleton } from '@material-ui/core';

export const SkeletonGrid = (cantidad: number) => {
  return [...new Array(cantidad)].map((_, index) => (
    <Grid item xs={6} sm={6} md={6} key={index}>
      <Skeleton sx={{ height: '250px' }} />
    </Grid>
  ));
};
